import React from "react";
const ButtonTooltip = ({ tooltip, last, className, children }) => {
    return (React.createElement("div", { className: className + " button__tooltip" },
        children,
        React.createElement("span", { className: "tooltip-text" + (last ? " last_tooltip" : "") }, tooltip)));
};
export default ButtonTooltip;
//# sourceMappingURL=index.js.map